import React, { Component } from 'react';
import Demo from '../Demo/Demo';
import './DemoBrowser.css';
// import fire from '../../fire';

class DemoBrowser extends Component {
  constructor() {
    super();
    this.state = {
      placeholderDisplay: 'block',
      stOlafDemos: [],
      carletonDemos: []
    }
  }

  // dynamically creates a demo object based on parameters
  // needed to actually render the props
  // since the demos are passed as a prop, they can be filtered in the parent
  _createDemo = (image, title, video, cat, status, contact) => {
    return (
      <Demo
        image={image}
        title={title}
        video={video}
        cat={cat}
        status={status}
        contact={contact} />
    )
  }

  render() {
    return (
      <div className="mainContainer">
        <div className="contentContainer">
          <div className="demoGrid">
              { this.props.demos.map(item => this._createDemo(item.img, item.title, item.video, item.cat, item.status, item.contact)) }
          </div>
        </div>
      </div>
    )
  }
}

export default DemoBrowser;



// WEBPACK FOOTER //
// ./src/components/DemoBrowser/DemoBrowser.js